/**
 * 🔒 2026-09-21 (Manak): who approves raw materials and BOMs — by ROLE, never by user name.
 * Mirror of backend/src/modules/warehouse/raw-material-approval.ts MASTERDATA_APPROVER_ROLES.
 * The server decides; this only chooses which buttons to show.
 */
export const MASTERDATA_APPROVER_ROLES: ReadonlySet<string> = new Set([
  'admin', 'owner', 'super_admin', 'production_manager', 'qa_manager', 'accounts_approver', 'store_keeper', 'buyer',
]);

export function isMasterdataApprover(user: { role?: { name?: string | null } | null } | null | undefined): boolean {
  return MASTERDATA_APPROVER_ROLES.has(String(user?.role?.name ?? '').trim().toLowerCase().replace(/[ -]+/g, '_'));
}
